export const products = { 
  product: [
    {
      title: 'Sabtu bersama bapak',
      price: '100000',
    },
  ]
}